import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.33301 3.53656L7.04703 0.882201C7.34109 0.594605 7.8184 0.594605 8.11246 0.882201V0.882201C8.40652 1.1698 8.40652 1.63662 8.11246 1.92422L4.83518 5.12946C4.55746 5.40107 4.10785 5.40107 3.83083 5.12946L0.553554 1.92422C0.259494 1.63662 0.259494 1.1698 0.553554 0.882201V0.882201C0.847614 0.594605 1.32493 0.594605 1.61899 0.882201L4.33301 3.53656Z"
          fill="#A3B0CC"
        />
      </svg>
    </>
  );
};
